module.exports = __webpack_public_path__ + "static/media/arrow.184646df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PreviewBook/arrow.svg
// module id = 146
// module chunks = 0